import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SignInDialogComponent } from '../sign-in-dialog/sign-in-dialog.component';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { StoreService } from 'src/app/core/store/store.service';

@Component({
  selector: 'molla-headers',
  templateUrl: './headers.component.html',
  styleUrls: ['./headers.component.scss']
})
export class HeadersComponent implements OnInit {
  currentUser: any;

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private authService: AuthenticationService,
    private storeService: StoreService
  ) {}

  ngOnInit(): void {
    this.currentUser = this.storeService.getItem('currentUser');
  }

  openLoginDialog(): void {
    this.modalService.open(SignInDialogComponent, {
      centered: true,
      windowClass: 'premium-login-modal'
    });
  }

  navigateTo(path: string): void {
    this.router.navigate([path]);
  }
}
